<template>
  <general-textarea
    label="Label"
    ref="labelSegmentContentDataInput"
    dense autofocus rows="1" no-resize
    v-model="$_label"
    v-bind:disabled="isImmutable"
  >
  </general-textarea>
</template>

<script>
import LabelSegmentData from '../../../modules/segmentDataTypes/LabelSegmentData.js';
import SegmentContentDataInputDefinition from '../../../modules/SegmentContentDataInputDefinition.js';
import GeneralTextarea from './GeneralTextarea.vue';

export const LabelSegmentContentDataInputDefinition = new SegmentContentDataInputDefinition(
  'LabelSegmentContentDataInput',
  LabelSegmentData.contentData,
);

export default {
  model: {
    event: 'update',
    prop: 'timelineSegmentContentData'
  },

  components: {
    GeneralTextarea,
  },

  watch: {
    timelineSegmentContentData() { this.$_updateHeight() },
  },

  props: {
    isImmutable:                { type: Boolean,                      required: true },
    timelineSegmentContentData: { type: LabelSegmentData.contentData, required: true },
  },

  data() {
    return {
      $_textareaElement: undefined,
    };
  },

  mounted() {
    this.$data.$_textareaElement = this.$refs.labelSegmentContentDataInput.$refs.input;
    this.$_updateHeight();
  },

  computed: {
    $_labelData: {
      get()          { return this.timelineSegmentContentData },
      set(labelData) { this.$emit('update', labelData) },
    },

    $_label: {
      get()      { return this.$_labelData.label },
      set(label) {
        let labelData = this.$_labelData.clone();
        labelData.label = label;
        this.$_labelData = labelData;
      },
    },
  },

  methods: {
    $_updateHeight() {
      this.$data.$_textareaElement.style.height = '';
      this.$nextTick(() => {
        this.$data.$_textareaElement.style.height = `${this.$data.$_textareaElement.scrollHeight}px`;
      });
    }
  },
}
</script>